import { Button, Input, Picker, Radio } from "react-vant";
import { prefix } from ".";
import { useEffect, useMemo, useState } from "react";
import ArrowClickIcon from "../svg/ArrowClickIcon";
import { getCascadeData, getDefaultPickerValues } from "@/utils/date-utils";
import { IObject, IPickUpOption } from "@/types/common-types";
import PhoneNumber from "../PhoneNumber";
import { trim } from "lodash";
import { TFunction } from "i18next";

interface IAddressInputProps {
  value?: string;
  onClick?: () => void;
  onChange?: (value: string) => void;
};

const TimeInput: React.FC<IAddressInputProps> = (props) => {
  const { value, onClick } = props;
  return (
    <div onClick={onClick} className={`${prefix}-input flex`}>
      <span>{value}</span>
      <ArrowClickIcon className={`${prefix}-input-icon flex`} />
    </div>
  )
};


interface ITakeawayProcessProps {
  t: TFunction<"common", undefined>;
  selectKey: string;
  showPickTime: boolean;
  visible: boolean;
  pickUpOption?: IPickUpOption; 
  onConfirm: (option?: any) => void;
  setSelectIndex: (value: string) => void;
  setShowPickTime: (value: boolean) => void;
  setShowTabs: (value: boolean) => void;
  setTitle: (value: string) => void;
};

const TakeawayProcess: React.FC<ITakeawayProcessProps> = (props) => {
  const {
    t,
    visible,
    selectKey,
    showPickTime,
    pickUpOption,
    onConfirm,
    setShowTabs,
    setTitle,
    setShowPickTime,
    setSelectIndex,
  } = props;

  const [cascaderData, setCascaderData] = useState<any[]>([]);
  const [value, setValue] = useState<string[]>([]);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [record, setRecord] = useState<IObject>({
    delivery_date: 'Immediately'
  });

  const validateRecord = (recordToValidate: IObject): boolean => {
    const requiredKeys = ['name', 'phone'];
    let pass = true;

    for (let i = 0; i < requiredKeys.length; i++) {
      const itemKey = requiredKeys[i];
      const value = recordToValidate[itemKey];
      if (!value || trim(value).length < 1) {
        pass = false;
        break;
      }

      if (itemKey === 'phone') {
        const inputValue = value.substring(value.indexOf(' ') + 1);
        const dialCode = value.substring(0, value.indexOf(' ')).replace('+', '');

        if (!inputValue || !dialCode || !trim(inputValue)) {
          pass = false;
          break;
        }
      }
    }

    return pass;
  };

  useEffect(() => {
    if (pickUpOption) {
      setRecord({
        ...pickUpOption
      });
      const isValid = validateRecord(pickUpOption);
      setDisabled(!isValid);
    } else {
      setRecord({
        delivery_date: 'Immediately'
      });
      setDisabled(true);
    }
  }, [pickUpOption, visible]);

  useEffect(() => {
    if (selectKey === '2') {
      setCascaderData(getCascadeData());
      setValue(getDefaultPickerValues());
    };
  }, [selectKey]);

  const handleChange = (values: any) => {
    const [selectedDate] = values;

    if (selectedDate !== value[0]) {
      let defaultAmPm = 'AM';
      const now = new Date();
      const currentHour = now.getHours();
      let defaultKey = 1;

      if (selectedDate === 'Today' && currentHour >= 12) {
        defaultAmPm = 'PM';
        defaultKey = 0;
      }

      const newSelectedTime = cascaderData[defaultKey].children[0].value;
      const newValues = [selectedDate, newSelectedTime, defaultAmPm];
      setValue(newValues);
      return;
    }

    setValue(values);
  };

  const handleSave = () => {
    if (showPickTime) {
      let value = 'Immediately';

      if (selectKey === '2') {
        value = getValueDispaly()
      }

      const newRecord = {...record};
      newRecord['delivery_date'] = value;

      setRecord(newRecord);
      setShowPickTime(false);
    } else {
      onConfirm(record);
    }
  };

  const handleShowPickTime = () => {
    setShowPickTime(true);
    setShowTabs(false);
    setTitle(t('pickUpTime'));
  };

  const getValueDispaly = () => `${value[0] || ''} ${value[1] || ''}${value[2] || ''}`;

  const valueDispay = useMemo(() => {
    return getValueDispaly();
    // eslint-disable-next-line
  }, [value]);

  const options = [
    {
      label: t('immediately'),
      name: '1',
    },
    // {
    //   label: t('scheduleForLater'),
    //   name: '2',
    // },
  ];

  const handleValuesChange = (key: string, value: string) => {
    const newRecord = {...record};
    newRecord[key] = value;

    const pass = validateRecord(newRecord);

    setRecord(newRecord);
    setDisabled(!pass);
  }

  return (
    <div className={`${prefix}-takeaway`}>
      <div className={`${prefix}-takeaway-content`}>
        {
          !showPickTime &&
          <div className={`${prefix}-takeaway-form`}>
            <div className={`${prefix}-takeaway-form-item`}>
              <label className="label">
                <span>{t('receiverName')}</span>
                <span>*</span>
              </label>
              <Input onChange={(value) => handleValuesChange('name', value)} value={record.name || ''} placeholder={t('receiverNamePlaceholder')} />
            </div>
            <div className={`${prefix}-takeaway-form-item`}>
              <label className="label">
                <span>{t('phoneNumber')}</span>
                <span>*</span>
              </label>
              <PhoneNumber onChange={(value) => handleValuesChange('phone', value)} value={record.phone || ''} />
            </div>
            <div className={`${prefix}-takeaway-form-item`}>
              <label className="label">
                <span>{t('pickUpTime')}</span>
                <span>*</span>
              </label>
              <TimeInput value={record.delivery_date === 'Immediately' ? t('immediately') : record.delivery_date} onClick={handleShowPickTime} />
            </div>
          </div>
        }
        {
          showPickTime &&
          <div className={`${prefix}-takeaway-selectTime`}>
            <Radio.Group value={selectKey} onChange={(name) => setSelectIndex(name)} defaultValue="1">
              {options.map(option => <Radio key={option.name} name={option.name}>{option.label}</Radio>)}
            </Radio.Group>
            {
              selectKey === '2' &&
              <div className={`${prefix}-takeaway-selectTime-content`}>
                <div className={`${prefix}-takeaway-selectTime-title`}>
                  <div>{t('chooseTime')}</div>
                  <div className="value">{valueDispay}</div>
                </div>
                <Picker
                  value={value}
                  placeholder={null}
                  showToolbar={false}
                  columns={cascaderData}
                  onChange={handleChange}
                />
              </div>
            }
          </div>
        }
        <Button disabled={disabled && !showPickTime} onClick={handleSave} type='primary'>{t('save')}</Button>
      </div>
    </div>
  )
};

export default TakeawayProcess;